import { render, staticRenderFns } from "./chart-panel.vue?vue&type=template&id=2848aa09&scoped=true"
import script from "./chart-panel.vue?vue&type=script&lang=js"
export * from "./chart-panel.vue?vue&type=script&lang=js"
import style0 from "./chart-panel.vue?vue&type=style&index=0&id=2848aa09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2848aa09",
  null
  
)

export default component.exports